import React from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import AccountIcon from "@mui/icons-material/AccountCircle";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import FNOLogo from "../../assets/images/fno-logo.png";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import SdCardIcon from "@mui/icons-material/SdCard";
import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { connect } from "react-redux";
import * as authenticationActions from "../../store/actions/authenticationActions";
import { Navigate } from "react-router-dom";
import Menu from '@mui/material/Menu';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import * as companyApi from "../../api/companyApi";
import { withRouter } from "./WithRouter";
import ButtonBase from "@mui/material/ButtonBase";

const drawerWidth = 290;
const drawerHeight = 970;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.anchorRef = null;
    this.state = {
      open: true,
      openDropdown: false,
      openmenu: "",
      selectedIndex: [1],
      redirect: false,
      anchorEl: null,
      companies: [],
    };
  }

  async componentDidMount() {
    try {
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleToggle = () => {
    this.setState({ openDropdown: (prevOpen) => !prevOpen });
  };

  handleClickAway = () => {
    this.setState({ openDropdown: false });
  };

  handleClickMyCompany = () => {
    this.setState({ openDropdown: false });
    return <Navigate to="/companylist" replace />;
  };


  handleSelectCompanyClick = async (event) => {
    this.setState({ anchorEl: event.currentTarget })
    const companies = await companyApi.getSelectedCompanies();
    if (companies) {
      this.setState({ companies });
      console.log(companies);
    }
  }

  handleSelect = async (company) => {
    this.setState({ anchorEl: null });
    const signedInUser = await companyApi.selectedCompany(company);
    if (signedInUser) {
      sessionStorage.setItem("token", JSON.stringify(signedInUser));
      const menu = this.getMenuItems(signedInUser);

      sessionStorage.setItem("menuitems", JSON.stringify(menu));
      const object = { signedInUser, menu };

      this.props.dispatch(authenticationActions.userSignedInSuccess(object));
      window.location.reload(false);
    }
  }

  getMenuItems = (signedInUser) => {
    const catalogsdata = require("../common/data.json");
    let roles = [];
    signedInUser.userRoles.forEach((arrayItem) => {
      roles.push(arrayItem.roleName);
    });

    const items = catalogsdata.catalogs.filter((c) =>
      c.permissions.some((p) => roles.includes(p))
    );

    var menuItems = items.filter((item) => {
      return item != null;
    });

    const menu = menuItems.map(({ permissions, ...keepAttrs }) => keepAttrs);
    return menu;
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  signout = () => {
    this.setState({ openDropdown: false });
    sessionStorage.clear();
    this.props.dispatch(authenticationActions.userSignedOutSuccess(null));
  };

  handleCollapse = (val) => {
    this.setState((state) => ({
      openmenu: { [val]: !state.openmenu[val] },
    }));
  };

  userSignedIn = () => {
    return sessionStorage.getItem("token") ? true : false;
  };

  handleSubmenu = () => {
    if (!this.userSignedIn()) {
      sessionStorage.clear();
      this.props.dispatch(authenticationActions.userSignedOutSuccess(null));
      return <Navigate to="/signin" replace />;
    }
  }

  showNavigationIcon = (menuName) => {
    switch (menuName) {
      case "Bedrifter":
        return (
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
        );
      case "Premier/Andel":
        return (
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
        );
      case "Avregninger":
        return (
          <ListItemIcon>
            <AssessmentIcon />
          </ListItemIcon>
        );
      case "Rapporter":
        return (
          <ListItemIcon>
            <DonutSmallIcon />
          </ListItemIcon>
        );
      case "Data":
        return (
          <ListItemIcon>
            <SdCardIcon />
          </ListItemIcon>
        );
      case "Grønt kort":
        return (
          <ListItemIcon>
            <DriveEtaIcon />
          </ListItemIcon>
        );
      case "Brukere":
        return (
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
        );
      case "Premier TFF":
        return (
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
        );
      case "Premier YFF":
        return (
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
        );
      case "Avregninger TFF":
        return (
          <ListItemIcon>
            <AssessmentIcon />
          </ListItemIcon>
        );
      case "Avregninger YFF":
        return (
          <ListItemIcon>
            <AssessmentIcon />
          </ListItemIcon>
        );
      case "Logg":
        return (
          <ListItemIcon>
            <SdCardIcon />
          </ListItemIcon>
        );
      default:
        break;
    }
  };

  showSubmenuLink = (menuName, submenuName) => {
    if (menuName === "Bedrifter") {
      switch (submenuName) {
        case "Oversikt":
          return "/companylist";
        case "Ny bedrift":
          return "/newcompany";
        default:
          return "/";
      }
    } else if (menuName === "Premier/Andel") {
      switch (submenuName) {
        case "Oversikt":
          return "/premiumlistadmin";
        case "Ny premie":
          return "/newpremiumadmin";
        case "Import TFF andel":
          return "/importtffdata";
        case "Årganger":
          return "/policyyearlistadmin";
        default:
          return "/";
      }
    } else if (menuName === "Premier TFF") {
      switch (submenuName) {
        case "Oversikt":
          return "/premiumlisttff";
        case "Ny Premie TFF":
          return "/newpremiumtff"
        case "Sist Registrerte Premie":
          return "/lastpremiumtff";
        case "Årganger TFF":
          return "/policyyearlisttff";
        default:
          return "/";
      }
    } else if (menuName === "Premier YFF") {
      switch (submenuName) {
        case "Oversikt":
          return "/premiumlistyff";
        case "Ny Premie YFF":
          return "/newpremiumyff";
        case "Sist Registrerte Premie":
          return "/lastpremiumyff";
        case "Årganger YFF":
          return "/policyyearlistyff";
        default:
          return "/";
      }
    } else if (menuName === "Avregninger") {
      switch (submenuName) {
        case "Oversikt":
          return "/clearinglistadmin";
        default:
          return "/";
      }
    } else if (menuName === "Avregninger TFF") {
      switch (submenuName) {
        case "Oversikt":
          return "/clearinglistTFF";
        case "Siste Avregn TFF":
          return "/lastclearingTFF";
        default:
          return "/";
      }
    } else if (menuName === "Avregninger YFF") {
      switch (submenuName) {
        case "Oversikt":
          return "/clearinglistYFF";
        case "Siste Avregn YFF":
          return "/lastclearingYFF";
        default:
          return "/";
      }
    } else if (menuName === "Rapporter") {
      switch (submenuName) {
        case "Innkalling":
          return "/";
        case "Status TFF/YFF":
          return "/statusreport";
        case "Premieinnberetningsstatus":
          return "/premiumreport";
        case "Status for saker":
          return "/casesstatus";
        case "Grunnlag for IBNR":
          return "/ibnrdata";
        case "Akkumelert dataimport res.":
          return "/accumulateddataimport";
        case "Premieandeler":
          return "/premiumshare";
        case "YFF økonomikontakter":
          return "/yffeconomycontacts";
        case "NAV kontakter":
          return "/navcontacts";
        default:
          return "/";
      }
    } else if (menuName === "Data") {
      switch (submenuName) {
        case "Import":
          return "/dataimport";
        case "Kontroll av skadedata":
          return "/validatedataimportresult";
        case "Innkalling":
          return "/datacaptialcall";
        case "Inntekter":
          return "/dataincome";
        case "Kostnader":
          return "/datacost";
        case "IBNR":
          return "/dataibnr";
        default:
          return "/";
      }
    } else if (menuName === "Brukere") {
      switch (submenuName) {
        case "Oversikt":
          return "/userlist";
        case "Ny bruker":
          return "/newuser";
        default:
          return "/";
      }
    } else if (menuName === "Grønt kort") {
      switch (submenuName) {
        case "Import":
          return "/gkimport";
        case "Importliste":
          return "/gkimportlist";
        case "Kvartaler":
          return "/gkquarters";
        case "Land":
          return "/gkcountry";
        default:
          return "/";
      }
    } else if (menuName === "Logg") {
      switch (submenuName) {
        case "Logg Detaljer":
          return "/log";
        default:
          return "/";
      }
    }
  };

  render() {
    const { theme } = this.props;

    if (!theme) {
      console.error("Theme is undefined in Header component!");
      return null;
    }

    const companyId = this.props.signedin
      ? this.props.signedin.companyId
      : sessionStorage.getItem("token")
        ? JSON.parse(sessionStorage.getItem("token")).companyId
        : "";

    if (this.props.signedin && !this.userSignedIn()) {
      sessionStorage.clear();
      this.props.dispatch(authenticationActions.userSignedOutSuccess(null));
      return <Navigate to="/signin" replace />;
    }

    const root = {
      display: "flex",
    }

    const toolbar = {
      paddingRight: 24,
    }
    const toolbarIcon = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 16px",
      height: "64px",
      minHeight: "64px",
      ...theme.mixins.toolbar
    }
    const appBar = {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    }
    const appBarShift = {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }
    const menuButton = {
      marginRight: 36,
    }
    const menuButtonHidden = {
      display: "none",
    }
    const title = {
      flexGrow: 1,
    }

    return (
      <div style={root} >
        <CssBaseline />
        <AppBar
          position="absolute"
          style={this.state.open ? { ...appBar, ...appBarShift } : appBar}
        >
          <Toolbar style={toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerOpen}
              style={this.state.open ? menuButtonHidden : menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Typography component="h1" variant="h6" color="inherit" noWrap style={title}>
              Avregning
            </Typography>
            {this.props.signedin || this.userSignedIn() ? (
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleSelectCompanyClick}
                >
                  <TouchAppIcon /> Velg bedrift
                </Button>
                <Menu
                  anchorEl={this.state.anchorEl}
                  keepMounted
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleClose}
                >
                  {this.state.companies.map((company) => (
                    <MenuItem key={company.companyId} onClick={() => this.handleSelect(company)}>
                      {company.companyName}
                    </MenuItem>
                  ))}
                </Menu>
                <span>&nbsp;&nbsp;</span>
              </div>
            ) : null}
            <ButtonGroup
              variant="contained"
              color="primary"
              ref={(anchorRef) => {
                this.anchorRef = anchorRef;
              }}
              aria-label="split button"
            >
              <Button component={Link} to="/profile">
                <AccountIcon /> <span>&nbsp;</span>
                {(this.props.signedin || this.userSignedIn()) && sessionStorage.getItem("token")
                  ? JSON.parse(sessionStorage.getItem("token")).fullName
                  : ""}
              </Button>
              {this.props.signedin || this.userSignedIn() ? (
                <Button
                  color="primary"
                  size="small"
                  onClick={this.handleToggle}
                >
                  <ArrowDropDownIcon />
                </Button>
              ) : (
                <Button component={Link} to="/signin">
                  Login
                </Button>
              )}
            </ButtonGroup>
            <Popper
              open={this.state.openDropdown}
              anchorEl={this.anchorRef}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={this.handleClickAway}>
                      <MenuList>
                        <MenuItem onClick={this.handleClickAway} component={Link} to="/profile">
                          Min Profil
                        </MenuItem>
                        <MenuItem
                          onClick={this.handleClickAway}
                          component={Link}
                          to={`companydetail/${companyId}`}
                        >
                          Min Bedrift
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={this.signout} component={Link} to="/signout">
                          Logg Ut
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          sx={{
            flexShrink: 0,
            width: this.state.open ? drawerWidth : 56, // Dynamic width change
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            "& .MuiDrawer-paper": {
              width: this.state.open ? drawerWidth : 56, // Ensure child elements respect width
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
              whiteSpace: "nowrap", // Prevents wrapping of elements
              overflowX: "hidden", // Hides content overflow when collapsed
              display: "flex",
              flexDirection: "column",
              height: drawerHeight,
              flexShrink: 0,
            },
          }}
        >
          <div style={toolbarIcon}>
            <Link to="/">
              <img src={FNOLogo} alt="Finans Norge" width={160} height={30} />
            </Link>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          {this.userSignedIn() ? (
            <List
              style={{
                width: drawerWidth,
              }}
            >
              {this.props.menuitems.map((menuObj, menuIndex) => (
                <div key={menuIndex}>
                  <ListItem button onClick={() => this.handleCollapse(menuObj.menu)}>
                    {this.showNavigationIcon(menuObj.menu)}
                    <ListItemText primary={menuObj.menu} />
                    {this.state.openmenu[menuObj.menu] ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  {menuObj.submenus.map((submenuObj, submenuIndex) => (
                    <Collapse
                      key={submenuIndex}
                      in={this.state.openmenu[menuObj.menu]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div"
                        disablePadding
                        style={{
                          background: "#f5f5f5",
                        }}>
                        <ButtonBase sx={{ width: "100%" }}>
                          <ListItem
                            button
                            activeStyle={{ backgroundColor: "#D3D3D3" }}
                            style={{
                              paddingLeft: 32,
                              width: "100%",
                              transition: "background-color 0.2s ease-in-out",
                              backgroundColor: this.props.location.pathname === this.showSubmenuLink(menuObj.menu, submenuObj)
                                ? "#D3D3D3"
                                : "transparent",
                            }}
                            component={NavLink}
                            to={this.showSubmenuLink(menuObj.menu, submenuObj)}
                            onClick={this.handleSubmenu}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#E5E5E5"}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                this.props.location.pathname === this.showSubmenuLink(menuObj.menu, submenuObj)
                                  ? "#D3D3D3"
                                  : "transparent";
                            }}
                          >
                            <ListItemIcon style={{ minWidth: "40px" }} />
                            <ListItemText primary={submenuObj} style={{ color: "black", zIndex: 10 }} />
                          </ListItem>
                        </ButtonBase>
                      </List>
                    </Collapse>
                  ))}
                </div>
              ))}
            </List>
          ) : null}
        </Drawer>
      </div >
    );
  }
}

function mapStateToProps(state) {
  const signedin = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : "";
  const menuItems = state.signedinuserobject
    ? state.signedinuserobject.menu
    : sessionStorage.getItem("menuitems")
      ? JSON.parse(sessionStorage.getItem("menuitems"))
      : [];

  return {
    signedin: signedin,
    menuitems: menuItems,
  };
}

export default withRouter(connect(mapStateToProps)(Header));
